import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
/* eslint-disable react/prop-types */
import React from 'react';
import { _DetailBar } from "./styles";
var DetailBar = function DetailBar(props) {
  var classNames = [props.className, props.selectedIndex === 0 ? 'first' : null, props.addingNote || props.onNewRequirementsTab ? 'expanded' : null].filter(function (e) {
    return !!e;
  });
  return /*#__PURE__*/React.createElement(_DetailBar, {
    className: classNames.join(' ')
  }, props.children);
};
export default DetailBar;